<div style=" display: inline;block-size: 10%;">

  <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder " style="padding-right: 0px;">

    <div class="col-md-6" style="display: inline-block;">

      <h2 style="margin-top:2%; ;margin-left: -11px;float: left;" class=" ng-binding">
        Material Availability Check
      </h2>

    </div>

    <div class="col-md-6" style="display: inline-block;position: relative; text-align: right;
    top: -13px;    padding: 0px; ">
    <span class="btn-blue" style="font-size: 13px; display: inline-block; padding: 4px 12px 4px; font-size: 15px; margin-left: 10px; float: right;" (click)="backBtn()">
      <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
    </span>
      <span class="btn btn-yellow fntSz" (click)="exportToExcel()" title="Export to Excel"
        style="cursor:pointer;margin-left: 10px;line-height: 23px; float: right;padding: 4px 10px;font-size: 13px"><span><i
            class="fa fa-file-excel-o" aria-hidden="true"></i></span></span>
            
    </div>
  </div>
</div>


<div class="col-md-3 col-sm-6 col-xs-6" style="display: inline-block; margin-top: 17px;">
  <select required="" class="mrgnLeft10 form-control " style="width:135px;margin-left:0px;width: 90%;"
    placeholder="Select Category">
    <option value="0" disabled="" selected="" hidden="">Select Category</option>
    <option id="select" value="2" class="ng-binding ng-scope">Electronics</option>
    <option id="select" value="3" class="ng-binding ng-scope">Eng.</option>
    <option id="select" value="4" class="ng-binding ng-scope">Food</option>
    <option id="select" value="5" class="ng-binding ng-scope">Furniture</option>
  </select>
  <!-- <input matInput placeholder="Select Product" tabindex="1" [matAutocomplete]="auto" class="autoselect">
  <mat-autocomplete #auto="matAutocomplete"> -->
  <!-- <mat-option *ngFor="let x of filteredCategory | async" [value]="x.cnm">
      <span>{{x.cnm}} </span>
    </mat-option> -->
  <!-- </mat-autocomplete> -->
</div>

<div class="col-md-6 col-sm-6 col-xs-6" style="display: inline-block">
  <input style="margin-left: 1%;" type="text" id="txtToDT" data-ng-model="numbersOfDays" maxlength="2"
    placeholder="Production Needed" class="autoselect">
  <input style="margin-left: 1% ;width: 71px;" type="text" class="autoselect" maxlength="2" disabled="disabled"
    value="piece(s)">
</div>

<div class="wrapper" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 0px;padding-top: 20px;">
  <table mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="material">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Material</label>
      </th>
      <td mat-cell *matCellDef="let element"> {{element.material}} </td>
    </ng-container>

    <ng-container matColumnDef="defcost">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label> Def Cost</label>
      </th>
      <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.defcost}} </td>
    </ng-container>

    <ng-container matColumnDef="requiredqty">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Required Qty</label>
      </th>
      <td mat-cell *matCellDef="let element" style="text-align: right;" maxlength=5> {{element.requiredqty}} </td>
    </ng-container>

    <ng-container matColumnDef="expusageqty">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Exp.Usage Qty</label>
      </th>
      <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.expusageqty}} </td>
    </ng-container>

    <ng-container matColumnDef="stockqty">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Stock Qty</label>
      </th>
      <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.stockqty}} </td>
    </ng-container>

    <ng-container matColumnDef="orderedqty">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Ordered Qty</label>
      </th>
      <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.orderedqty}} </td>
    </ng-container>

    <ng-container matColumnDef="needtobuyqty">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Need to Buy Qty</label>
      </th>
      <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.needtobuyqty}} </td>
    </ng-container>

    <ng-container matColumnDef="unit">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Unit</label>
      </th>

      <td mat-cell *matCellDef="let element"> {{element.unit}} </td>
    </ng-container>

    <!-- <ng-container matColumnDef="leadtime">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Leadtime</label>
        </th>
        <td mat-cell *matCellDef="let element"> {{element.leadtime}} </td>
      </ng-container> -->

    <!-- <ng-container matColumnDef="edit">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label> </label>
        </th>
        <td mat-cell *matCellDef="let element"> <i style="color: rgb(243, 163, 16); cursor: pointer; " class="fa fa-pencil"></i> </td>
      </ng-container> -->

    <!-- <ng-container matColumnDef="delete">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label> </label>
        </th>
        <td mat-cell *matCellDef="let element"> <i style="color: rgb(15, 15, 15); cursor: pointer;"  class="fa fa-trash"></i> </td>
      </ng-container> -->

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <!-- Angular 8 pagination -->
  <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
  </mat-paginator>
</div>